import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'primereact/dialog';

import ButtonSp from '../../components/ButtonSp';
import AfvService from '../../services/AfvService';
import { errorHandle } from '../../util/functions';
import { NOMES_CONTAINER, NOMES_SITUACAO } from './util';

// Status do AFV no servidor (container, porta, banco, ultimo backup) e o fim do log
function DialogoStatus(props) {
  DialogoStatus.propTypes = {
    numeroContrato: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  const { numeroContrato, onClose } = props;
  const [status, setStatus] = useState(null);
  const [logs, setLogs] = useState('');

  useEffect(() => {
    async function carrega() {
      try {
        setStatus(await AfvService.status(numeroContrato));
      } catch (err) {
        errorHandle(err);
      }
    }
    carrega();
  }, [numeroContrato]);

  async function carregaLogs() {
    try {
      setLogs((await AfvService.logs(numeroContrato, 200)) || '(log vazio)');
    } catch (err) {
      errorHandle(err);
    }
  }

  const s = status ? status.servidor : {};
  const linhas = status
    ? [
        ['Cliente', status.cliente ? status.cliente.nomeFantasia || status.cliente.nome : '-'],
        ['Situação', NOMES_SITUACAO[status.situacao] || status.situacao],
        ['Módulo AFV (qtd)', status.qtdAfv],
        ['Porta', s.porta],
        ['Container', NOMES_CONTAINER[s.container] || s.container],
        ['No ar desde', s.iniciado_em ? s.iniciado_em.replace('T', ' ') : '-'],
        ['Pasta', s.pasta],
        ['Banco', s.banco === 'sim' ? `sim (${s.banco_tamanho})` : 'não'],
        ['Último backup', s.ultimo_backup || '-'],
        ...(s.pm2_legado ? [['PM2 (AFV antigo)', s.pm2_legado]] : []),
      ]
    : [];

  return (
    <Dialog
      footer={
        <div>
          <ButtonSp
            className="p-button-secondary"
            icon="pi pi-list"
            label="Ver log"
            onClick={carregaLogs}
          />
          <ButtonSp
            className="p-button-secondary"
            icon="pi pi-times"
            label="Fechar"
            onClick={onClose}
          />
        </div>
      }
      header={`AFV - contrato ${numeroContrato}`}
      visible
      modal
      style={{ minWidth: '320px', maxWidth: '900px', width: '95%' }}
      onHide={onClose}
    >
      <div className="p-grid">
        {linhas.map(([rotulo, valor]) => (
          <React.Fragment key={rotulo}>
            <div className="p-col-5 p-sm-3" style={{ fontWeight: 600 }}>
              {rotulo}
            </div>
            <div className="p-col-7 p-sm-9">{valor}</div>
          </React.Fragment>
        ))}
        {logs ? (
          <div className="p-col-12">
            <pre
              style={{
                maxHeight: 360,
                overflow: 'auto',
                background: '#1e1e1e',
                color: '#d4d4d4',
                padding: 8,
                fontSize: 12,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
              }}
            >
              {logs}
            </pre>
          </div>
        ) : null}
      </div>
    </Dialog>
  );
}

export default DialogoStatus;
